import type { ISignUpResult } from "amazon-cognito-identity-js";
import { FinalUser, LoginCredentials, RegistrationData } from "../types/auth";
import { Cognito } from "./cognito";

// Amplify.configure(outputs);

export class AuthService {
  private static instance: AuthService;
  private baseUrl: string = "/api/auth";

  private constructor() {}

  static getInstance(): AuthService {
    if (!AuthService.instance) {
      AuthService.instance = new AuthService();
    }
    return AuthService.instance;
  }

  async login(credentials: LoginCredentials): Promise<FinalUser> {
    const cognito = Cognito.getInstance();
    return cognito.signIn(credentials.email, credentials.password);
  }

  async register(data: RegistrationData): Promise<ISignUpResult> {
    const cognito = Cognito.getInstance();
    const response = await cognito.signup(data.email, data.password, data);
    return response;
  }

  async logout(): Promise<void> {
    // In production, this would invalidate the token on the server
    return Promise.resolve();
  }

  async resetPassword(email: string): Promise<void> {
    // In production, this would trigger a password reset email
    return Promise.resolve();
  }

  async confirmRegistration(code: string) {
    const cognito = Cognito.getInstance();
    return cognito.confirmRegistration(code);
  }

  async verifyEmail(token: string): Promise<void> {
    // In production, this would verify the email verification token
    return Promise.resolve();
  }

  async refreshToken(refreshToken: string): Promise<{ token: string }> {
    // In production, this would get a new access token using the refresh token
    return { token: "new-mock-token" };
  }

  async updatePassword(
    currentPassword: string,
    newPassword: string
  ): Promise<void> {
    // In production, this would update the user's password
    return Promise.resolve();
  }

  async requestEmailVerification(): Promise<void> {
    // In production, this would send a new verification email
    return Promise.resolve();
  }

  async resendVerificationCode(): Promise<unknown> {
    const cognito = Cognito.getInstance();

    return cognito.resendVerificationCode();
  }
}
